import React, { ReactNode } from 'react';
import { Dialog } from 'primereact/dialog';
import AnimatedButton from '../../../custom/AnimatedButton';
import Icon from '../../../../icons/Icon';
import LanguageUtil from '../../../../util/LanguageUtil';

interface TransactionApiUpdateDialogProps {
  visible: boolean;
  onRefresh: () => void;
}

const TransactionApiUpdateDialog = ({ visible, onRefresh }: TransactionApiUpdateDialogProps): ReactNode => {
  const title: string = LanguageUtil.get({
    id: 'messages.transactionApiUpdate.title',
    defaultMessage: 'Transaction updated',
  });
  const description: string = LanguageUtil.get({
    id: 'messages.transactionApiUpdate.description',
    defaultMessage: 'This transaction was updated via API. Refresh to see the latest data.',
  });
  const refreshLabel: string = LanguageUtil.get({
    id: 'messages.transactionApiUpdate.refresh',
    defaultMessage: 'Refresh',
  });

  return (
    <Dialog
      visible={visible}
      onHide={onRefresh}
      closable={false}
      dismissableMask={false}
      closeOnEscape={false}
      position='center'
      showHeader={false}
      className='w-[462px] !rounded-lg shadow-lg'
      contentClassName='!pt-8 !pb-6'
      maskClassName='!bg-black !bg-opacity-30'
    >
      <div className='flex flex-col items-center gap-y-5 pb-2'>
        <Icon icon='info' size={40} className='text-primary' />
        <div className='flex flex-col gap-y-2'>
          <div className='text-xl font-semibold text-f-black-1 text-center'>{title}</div>
          <div className='text-xs text-f-black-3 text-center max-w-xs'>{description}</div>
        </div>
        <AnimatedButton icon='refresh' text={refreshLabel} customType='primary' className='!w-[160px]' onClick={onRefresh} />
      </div>
    </Dialog>
  );
};

export default TransactionApiUpdateDialog;
